<template>
  <div>
     <section class="content">
        <!-- Default box -->
        <div class="container-fluid">
            <router-link :to="{name: 'add-collateral-register', params: { id: $route.params.id, bid: $route.params.bid, tab: 'loan-collateral-tab'  } }"  @click="changeRoute($store.state.NAVIGATION.selectedIndex)" class="btn bg-gray margin">Add Collateral</router-link> &nbsp;
        </div>
     </section>
      <section name="collateral-details" class="mt-3" v-if="items.length">
          Total Collateral Value: <b>{{currency(TotalCollateral)}}</b></br>
          Total Loan Principal to Value (LTV) Ratio: <b>125%</b></br>
          Total Loan Outstanding to Value (LTV) Ratio: <b>200%</b></br>
          
          <div class="row mt-3">
            <template v-for="item in items">
                <div class="col-sm-12">
                    <hr class="hrcolor">
                    <template v-if="item.collateral_photo !== ''">
                          <img :src="item.collateral_photo" alt="..." width="200">
                    </template>
                    <h3 class="no-margin text-bold text-green">{{item.product_name}}</h3>
                    <div class="row">
                      <div class="col-sm-4">
                        <b>Current Status:</b> <span class="pull-right">Deposited into Branch</span><br>
                        <b>Value:</b> <span class="pull-right">{{ currency(item.value)}}</span><br/>
                        <b>Condition:</b> <span class="pull-right">{{item.condition}}</span>
                          <br>
                      </div>
                      <!-- /.col -->
                      <div class="col-sm-4">
                        <template v-if="item.name"><b>Type:</b> <span class="pull-right">{{item.name}}</span><br/></template>
                        <template v-if="item.model_name"><b>Model Name:</b> <span class="pull-right">{{item.model_name}}</span><br/></template>
                        <template v-if="item.model_number"><b>Model Number:</b> <span class="pull-right">{{item.model_number}}</span><br/></template>
                        <template v-if="item.serial_number"><b>Serial Number:</b> <span class="pull-right">{{item.serial_number}}</span><br/></template>
                        <template v-if="item.colour"><b>Colour:</b> <span class="pull-right">{{item.colour | capitalize}}</span><br/></template>
                        <template v-if="item.manufacture_date"><b>Date of Manufacture:</b> <span class="pull-right">{{item.manufacture_date}}</span><br/></template>
                        <template v-if="item.mileage"><b>Mileage:</b> <span class="pull-right">{{item.mileage}}</span><br/></template>
                        <template v-if="item.registration_number"><b>Registration Number:</b> <span class="pull-right">{{item.registration_number}}</span><br/></template>
                        <template v-if="item.engine_number"><b>Engine Number:</b> <span class="pull-right">{{item.engine_number}}</span><br/></template>
                      </div>
                      <!-- /.col -->
                      <div class="col-sm-4">
                        <b>Register Date:</b> <span class="pull-right">{{item.register_date}}</span><br/>
                        <b>Address:</b> <span class="pull-right">{{item.address}}</span>
                      </div>
                      <!-- /.col -->
                    </div>
                  <div class="row">
                      <div class="col-sm-6">
                          <h4 class="text-bold text-red mt-4">History:</h4>
                          <table class="table table-bordered">
                              <tbody><tr>
                                  <th>Status</th>
                                  <th>Date</th>
                              </tr>
                              <tr>
                                  <td>{{item.status_name}}</td>
                                  <td>{{item.current_status_date}}</td>
                              </tr>
                          </tbody></table>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-12 margin-top" style="text-align:center">
                        <div class="btn-group-horizontal">
                          <router-link :to="{ name: 'edit-collateral-register', params: { id: $route.params.id, cid: item.id, tab: 'loan-collateral-tab'  }}" class="btn bg-gray margin">Edit</router-link>&nbsp;
                          <!-- <a type="button" class="btn bg-gray margin" href="https://x.loandisk.com/collateral/add_collateral.php?edit_collateral=1&amp;collateral_register_id=171644&amp;tab=tab_collateral#link_loan">Transfer to another loan</a>&nbsp; -->
                          <button type="button" class="btn bg-gray margin confirm_action" @click="deleteItem(item.id)">Delete</button>
                        </div>
                      </div>
                    </div>
                    <!-- /.row -->
                  </div>
            </template>
          </div>
      </section>
    </div>
  </template>
  
  <script>
    export default {
    
      data() {
        return {
           items:[]
        }
      },

      created(){
        this.collateralRegister();
      },

      methods: {
        async collateralRegister(){
          let response = await axios.get('api/collateralRegister/find/' + this.$route.params.id + '/list')
          this.items = response.data
        }, 

        deleteItem(id) {
          /* USING SWEET ALERT */
            this.$swal({
                title: 'Are you sure?',
                text: 'You can\'t revert your action',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes Delete it!',
                cancelButtonText: 'No, Keep it!',
                showCloseButton: false,
                showLoaderOnConfirm: true,
                })
                .then((isConfirm) => {
                  if (isConfirm === true) {
                    axios.delete('api/collateralRegister/' + id + '/delete')
                          .then(response => {
                            this.collateralRegister(); // reloader 
                            this.$swal('Deleted', 'You successfully deleted this record', 'success')
                          })
                        .catch(response => {
                          console.log(response);
                          this.$swal('Error Code', 'Please contact Web developer', 'error')
                        });
                    }
                })  
            },
      },

      computed: {
        imgpreview(){
            let data = window.axios.defaults.baseURL + '/images/'
            return data
         },
         TotalCollateral: function() {
            let sum = 0;
            this.items.forEach(function(item) {
                sum += parseFloat(item.value);
            });
            return sum;
          },
       },
    }
  </script>
  <style>
    .hrcolor {
      color: #000;
      border-color: #000;
      background-color: #000;
    }
  </style>